<template>
 <div class="c-student">
  <div class="c-student__head">
    <i class="head-icon"/>
    <p class="head-title">学生完成情况分布</p>
  </div>

  <div class="c-student__spread" v-if="spreadData.length">
    <div class="spread-left">
      <el-table
      ref="singleTable"
      :data="spreadData"
      :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
      highlight-current-row
      @cell-mouse-enter="enter"
      @cell-mouse-leave="leave"
      style="width: 100%">
        <el-table-column
          prop="level"
          label="完成情况"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="spread-right">
      <div class="spread-right__header">
        学生（正答率）
      </div>
      <div class="spread-right__content" v-if="stuTotalList.length">
        <div class="content-item" v-for="(child, index) in stuTotalList"
        :key="`stu_${index}`" @click="queryStudentReport(child)">
          <span v-if="type===1">
            {{child.student_name}}：{{(child.avg_right_rate*100).toFixed(0)}}%</span>
          <p v-else>{{child.student_name}}：{{(child.avg_right_rate*100).toFixed(0)}}%</p>
        </div>
      </div>
      <div class="student-empty" v-if="!stuTotalList.length">
        <img src="../../images/empty.png" alt="">
        <p class="empty-text">暂无数据</p>
      </div>
    </div>
  </div>

  <div class="c-student__spread" v-else>
    <el-table
    ref="singleTable"
    :data="spreadData"
    :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
    style="width: 100%">
      <div slot="empty" class="no-data">
        <emptyContent/>
      </div>
      <el-table-column
        prop="level"
        label="完成情况"
        align="center"
        width="200px">
      </el-table-column>
        <el-table-column
        prop="stu_list"
        label="学生（正答率）"
        align="center">
      </el-table-column>
    </el-table>
  </div>

 </div>
</template>

<script>
import { openTab } from '@/utils';
// import { number } from 'echarts';
// import { getStudentScoreList } from '../../../api/pt';
import emptyContent from '../../components/empty-content.vue';

export default {
  name: 'PracticeStudentDetail',
  components: {
    emptyContent,
  },
  props: {
    maxLength: {
      type: Number,
      default: () => 0,
    },
    studentData: {
      type: Array,
      default: () => [],
    },
    spreadData: {
      type: Array,
      default: () => [],
    },
    changeData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stuTotalList: [],
      studentList: [],
      timer: null,
      changeColumn: {},
    };
  },
  watch: {
    changeData(v) {
      this.changeColumn = v;
    },
    studentData(v) {
      this.studentList = v;
    },
    spreadData(v) {
      if (v.length) {
        this.$nextTick(() => {
          this.$refs.singleTable.setCurrentRow(v[0]);
          this.stuTotalList = v[0].stu_list;
          this.type = v[0].type;
        });
      }
    },
  },
  methods: {
    // hover离开后定位到离开hover的位置
    leave(row) {
      this.spreadData.forEach((item) => {
        if (item.level === row.level) {
          this.$refs.singleTable.setCurrentRow(item);
          this.stuTotalList = item.stu_list;
          this.type = item.type;
        }
      });
    },
    // hover触发处理
    enter(row) {
      this.$refs.singleTable.setCurrentRow({});
      this.spreadData.forEach((item) => {
        if (item.level === row.level) {
          this.stuTotalList = item.stu_list;
          this.type = item.type;
        }
      });
    },
    onSearchClick() {
      // change后的值处理
      if (Object.keys(this.changeColumn).length) {
        this.getStudentScoreList(this.searchName, this.changeColumn);
        return;
      }
      this.getStudentScoreList(this.searchName, {});
    },
    // 正答率样式添加
    getRightClass(value) {
      if (value === -1) {
        return 'default';
      }
      if (value >= 70) {
        return 'level2';
      }
      if (value >= 40) {
        return 'level1';
      }
      return 'level3';
    },
    queryStudentReport(item) {
      if (this.type !== 1) return;
      let params = '';
      let rout = '';
      if (Number(this.$route.query.fromType) === 3) { // mt
        rout = '/mt-web/transition';
        params = `userId=${item.user_id}&hwId=${this.spreadData[0].evaluate_id}`;
      } else if (Number(this.$route.query.fromType) === 4) {
        rout = '/amt-web/task';
        params = `userId=${item.user_id}&courseId=${item.course_id}&topicId=${
          item.topic_id}&sectionId=${item.section_id}&subjectId=${
          item.subject_id}&basename=${item.base_name}&sModule=0&noCache=0`;
      }
      const isProduction = !window.location.host.includes('dev');
      // 区分线上和测试环境
      const address = isProduction
        ? 'http://jzjx.classba.cn'
        : 'http://jzjx.test.classba.cn'; // 测试环境
      if (params) {
        // 跳到报告页需要item.ts_id参数
        const url = `${address}${rout}?${params}`;
        openTab(url);
      }
    },

  },

};
</script>

<style lang="scss" scoped>
.c-student{
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding-top:50px;
  &__spread{
    display: flex;
    padding:20px;
    .spread-left{
      width:28%;
      /deep/.el-table__row{
        height: 94px;
      }
    }
    .spread-right{
      width:72%;
      min-height:286px;
      border:1px solid #F0F2F5;
      background:#f5f7fa;
      &__header{
        height:47px;
        text-align:center;
        line-height:47px;
        background:#F0F2F5;
        color:rgb(144, 147, 153);
        font-weight: 600;
        font-size:14px;
        font-family: Arial, Helvetica, sans-serif;
      }
      &__content{
        font-size:14px;
        min-height:239px;
        color:#606266;
        overflow:auto;
        font-family: Arial, Helvetica, sans-serif;
        clear:both;
        .content-item{
          width: 20%;
          height: 47px;
          line-height: 47px;
          text-align: center;
          float: left;
          span{
            cursor: pointer;
            color: #1989fa;
          }
        }
      }
    }
  }
  &__head{
    padding-left:19px;
    position: relative;
    .head-icon{
      display: block;
      background:url('~@/views/pt/images/class_bg.png');
      background-size:cover;
      width:38px;
      height:29px;
    }
    .head-title{
      position: absolute;
      top:5px;
      left:34px;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
    }
    .head-operate{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding:25px;
      .el-button {
        border-radius: 0 4px 4px 0;
      }
      .el-input {
        width: 243px;
        vertical-align: bottom;
        /deep/ .el-input__inner {
          border-radius: 4px 0 0 4px;
        }
      }
    }
  }
  &__table{
    padding:0 20px;
    .disable-color{
      color:#909399
    }
  }
}

/deep/ .el-table__body tr.current-row>td {
  background-color: #f5f7fa;
}

.no-data{
  line-height: 1.8;
  padding: 30px 0;
}

 .student-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #C0C4CC;
    font-size: 16px;
    img {
      width: 200px;
      margin-top: 35px;
    }
    .empty-text {
      color: rgba(0,0,0,0.6);
    }
  }
</style>
